import React, { useContext, useEffect, useState } from 'react'
import { BottomDiv, ButtonContainer, ButtonDiv, CloseDiv, Container, DimensionsFieldsDiv, FormData, Header, InputData, InputDiv, InputLabel, SelectData, ShortField, TabDiv, TabsDiv, TabText } from './style'
import { fieldsAndValues } from './utils'
import axios from 'axios'
import { ServicesContext } from '../../../contexts/ServicesContext'
import close from '../../../assets/close-icon.svg'
import plus from '../../../assets/productions/plus.svg'
import disk from '../../../assets/productions/disk.svg'
import { useNavigate } from 'react-router-dom'
import ModalTest from '../../BaseModal'

interface findMachineType{
  name:string
}

const CreateServiceModal:React.FC = () => {
  const [ formData, setFormData ] = useState<{stages:string[], quantity:number}>({stages:[], quantity:0})
  const [ incorrectData, setIncorrectData ] = useState<boolean>(false)
  const [ stages, setStages ] = useState<findMachineType[]>([])
  const navigate = useNavigate()

  const handleSubmitForm = async() => {
    axios.post(`${process.env.REACT_APP_PRODUCTION_FLOW_BASE_URL}/service`, formData)
      .then(response => {
        if(response.data){
          navigate('../')
        }
        return
      })
      .catch(error => {
        console.error(error)
      })
  }

  const findAllStages = async() => {
    try{
      const response = await axios.get(`${process.env.REACT_APP_PRODUCTION_FLOW_BASE_URL}/stages`)
      setStages(response.data)
    }catch(error){
      console.error('Erro ao procurar as máquinas', error)
    }
  }
  
  return(
    <ModalTest>
      <Container>
        <Header>
          <h2>Criar ordem de produção</h2>
          <CloseDiv onClick={() => navigate(-1)}> <img src={close} /> </CloseDiv>
        </Header>
          <FormData>
            {fieldsAndValues.map((item, index) => (
              <InputDiv key={index}>
                <InputLabel>{item.label}</InputLabel>
                {item.type === 'select' ? (
                  <SelectData 
                    value='' 
                    onFocus={() => findAllStages()}
                    onChange={(e) => setFormData(prev => ({...prev, stages:[...prev.stages, e.target.value]}))}
                  >
                    <option value=''>Selecione</option>
                    {stages.map((stage, index) => (
                      <option key={index} value={stage.name}>{stage.name}</option>
                    ))}
                  </SelectData>
                ):
                  <InputData 
                    type={item.type}
                    onChange={(e) => setFormData(prev => ({...prev, [item.value]: e.target.value}))} 
                  />
                }
                {item.value === 'stages' && (
                  <TabsDiv>
                    {formData.stages.map((stage, index) => (
                      <TabDiv key={index}>
                        <TabText>{stage}</TabText>
                      </TabDiv>
                    ))}
                  </TabsDiv>
                )}
              </InputDiv>
            ))}
          </FormData>
          <BottomDiv>
          <span>{incorrectData === true && <>Preencha todos os campos</>}</span>
            <ButtonContainer>
              <ButtonDiv onClick={(() => navigate(-1))} className='cancel'>Cancelar</ButtonDiv>
              <ButtonDiv onClick={() => handleSubmitForm()}>
                <img src={plus} /> Cadastrar
              </ButtonDiv>
            </ButtonContainer>
          </BottomDiv>
      </Container>
    </ModalTest>
  )
}

export default CreateServiceModal